import React from 'react'
import PropTypes from 'prop-types'
import { Dropdown, Popover } from 'antd'
import ColorPicker from '@components/ColorPicker'

import classnames from 'classnames'
import _ from 'lodash'

const DEFAULT_ICON_LIST = [
  { icon: '', background: 'transparent', color: '#909399' },
  { icon: 'title_line_01', background: 'transparent', color: '#909399' },
  { icon: 'title_line_02', background: 'transparent', color: '#909399' },
  { icon: 'title_line_03', background: 'transparent', color: '#909399' },
  { icon: 'title_line_04', background: 'transparent', color: '#909399' },
  { icon: 'title_line_05', background: 'transparent', color: '#909399' },
  { icon: 'title_line_06', background: 'transparent', color: '#909399' },
  { icon: 'title_line_07', background: 'transparent', color: '#909399' },
  { icon: 'title_line_08', background: 'transparent', color: '#909399' },
  { icon: 'title_line_09', background: 'transparent', color: '#909399' },
  { icon: 'title_line_10', background: 'transparent', color: '#909399' },
]
const DEFAULT_PLAIN_ICON_LIST = [
  { icon: 'title_plain_01', background: 'transparent', color: '#909399' },
  { icon: 'title_plain_02', background: 'transparent', color: '#909399' },
  { icon: 'title_plain_03', background: 'transparent', color: '#909399' },
  { icon: 'title_plain_04', background: 'transparent', color: '#909399' },
  { icon: 'title_plain_05', background: 'transparent', color: '#909399' },
  { icon: 'title_plain_06', background: 'transparent', color: '#909399' },
  { icon: 'title_plain_07', background: 'transparent', color: '#909399' },
  { icon: 'title_plain_08', background: 'transparent', color: '#909399' },
  { icon: 'title_plain_09', background: 'transparent', color: '#909399' },
  { icon: 'title_plain_10', background: 'transparent', color: '#909399' },
  { icon: 'title_plain_11', background: 'transparent', color: '#909399' },
]
export const DEFAULT_ICON_COLOR = [
  { icon: '', background: '#F0454C', color: '' },
  { icon: '', background: '#2CD781', color: '' },
  { icon: '', background: '#2492FC', color: '' }
]

class Icon extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    disableKeys: PropTypes.array,
    onChange: PropTypes.func
  }
  static defaultProps = {
    disableKeys: [],
    data: {
      icon: '',
      color: '',
    }
  }

  constructor(props) {
    super(props)
    const { data } = props
    this.state = {
      icon: (data && data.icon) || '',
      color: (data && data.color) || '',
      visible: false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.data, nextProps.data)) {
      const { data } = nextProps
      this.setState({
        icon: (data && data.icon) || '',
        color: (data && data.color) || '',
      })
    }
  }

  render() {
    return (
      <div>
        {this.renderStyleConfig()}
      </div>
    )
  }

  renderStyleConfig = () => {
    const { icon, color, visible } = this.state
    const currentColor = color || ''
    const configMenu = (
      <div className="cells-dropdown-overlay style-icon" style={{ height: '390px' }}>
        <div className="default-color-option" style={{ height: '124px' }}>
          <ul>
            {
              DEFAULT_ICON_LIST.map((i, _index) => {
                const isSelected = i.icon === icon
                return (
                  <li onClick={this.handleChangeStyle.bind(this, i, 'icon')} key={`render-style-icon-config-${_index}`}>
                    {i.icon ? this.generateIcon(i.color, i.background, i.icon, isSelected, 'icon') :
                      <span style={{ ...this.STYLE_SHEET.iconWrapper, ...this.STYLE_SHEET.noText }}>无</span>}
                  </li>
                )
              })
            }
          </ul>
        </div>
        <div className="default-color-option" style={{ height: '124px' }}>
          <ul>
            {
              DEFAULT_PLAIN_ICON_LIST.map((i, _index) => {
                const isSelected = i.icon === icon
                return (
                  <li onClick={this.handleChangeStyle.bind(this, i, 'icon')} key={`render-style-icon-config-${_index}`}>
                    {i.icon ? this.generateIcon(i.color, i.background, i.icon, isSelected, 'icon') :
                      <span style={{ ...this.STYLE_SHEET.iconWrapper, ...this.STYLE_SHEET.noText }}>无</span>}
                  </li>
                )
              })
            }
          </ul>
        </div>
        <div className="default-color-option" style={{ height: '40px', border: 'none' }}>
          <ul>
            {
              DEFAULT_ICON_COLOR.map((i, _index) => {
                const isSelected = i.background === color
                return (
                  <li onClick={this.handleChangeStyle.bind(this, i, 'color')}
                      key={`render-style-icon-color-config-${_index}`}>
                    {this.generateIcon(i.color, i.background, i.icon, isSelected, 'color')}
                  </li>
                )
              })
            }
          </ul>
        </div>
        <div className="custom-color-option" style={{ height: '60px' }}>
          <div className="custom-option-title">
            自定义颜色
          </div>
          <div className="custom-option-config">
            <Popover
              content={
                <ColorPicker
                  color={color || 'transparent'}
                  changeAtOnce={false}
                  onSure={this.handleConfirmColorChange.bind(this, 'color')}
                  onHide={this.handleHideColorPickerPopover}
                  disableAlpha={false}
                />
              }
              trigger="click"
              overlayStyle={{ zIndex: 1060 }}
              placement="bottomLeft"
              className="table-cell-config-color-picker-popover-container"
            >
              <div style={{ float: 'left' }}>
                <span className={`custom-option-round ${!color ? 'no-color' : ''}`}
                      style={{ background: color || 'transparent' }}/>
              </div>
            </Popover>
          </div>
        </div>
      </div>
    )

    return (
      <div className="cell" style={{ width: 50 }}>
        <Dropdown
          trigger={['click']}
          overlay={configMenu}
          placement='bottomLeft'
          visible={visible}
          onVisibleChange={this.handleChangeVisible.bind(this)}
        >
          <div className='config-style-wrapper config-style-icon-wrapper' style={this.STYLE_SHEET.styleWrapper}>
            {
              icon ? this.generateIcon(currentColor, 'transparent', icon) :
                <span style={{ ...this.STYLE_SHEET.iconWrapper, ...this.STYLE_SHEET.noText }}>无</span>
            }
          </div>
        </Dropdown>
      </div>
    )
  }

  generateIcon = (color, background, icon, selected, type) => {
    const wrapperClassName = classnames({
      selected,
      'config-icon-wrapper': true,
      'no-border': type === 'icon' && !selected
    })
    const borderStyle = type === 'icon' && !selected ? { border: '1px solid #fff' } : {}
    const borderSelected = selected ? { border: '1px solid #3377FF' } : {}
    return (
      <span className={wrapperClassName}
            style={{ background, ...this.STYLE_SHEET.iconWrapper, ...borderStyle, ...borderSelected }}>
        {icon && <i className={`iconfont icon-${icon}`} style={{ color }}/>}
      </span>
    )
  }
  handleChangeVisible = (status) => {
    this.setState({
      visible: status
    })
  }

  handleChangeStyle(item, type, e) {
    e.preventDefault()
    let value = item[type]
    if (type === 'color') {
      value = item['background']
    }
    this.setState({
      [type]: value
    }, () => {
      this.props.onChange(this.state)
    })
  }

  handleConfirmColorChange = (type, color) => {
    this.setState({
      color
    }, () => {
      this.props.onChange(this.state)
    })
  }
  handleHideColorPickerPopover = () => {
    // 触发关闭popover
    const overlay = $('.cells-dropdown-overlay')[0]
    overlay && overlay.dispatchEvent(new CustomEvent('mousedown', { bubbles: true }))
  }

  STYLE_SHEET = {
    styleWrapper: {
      textAlign: 'center',
      height: 30,
      width: 50,
      background: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 2,
      border: '1px solid #0000',
      transition: 'border .3s',
      cursor: 'pointer'
    },
    iconWrapper: {
      borderRadius: '100%',
      display: 'inline-block',
      width: 24,
      height: 24,
      fontSize: 12,
      lineHeight: '22px',
      textAlign: 'center',
      boxShadow: '0 2px 4px 0 rgba(1, 7, 14, 0.06)',
      border: '1px solid #ebedf0',
    },
    iconSelected: {
      borderColor: '#3377FF'
    },
    noText: {
      color: '#909399',
      boxShadow: '0 2px 4px 0 rgba(1, 7, 14, 0.06)'
    }
  }
}

export default Icon
